import React from 'react';

import {
	LineChart,
	Line,
	XAxis,
	YAxis,
	CartesianGrid,
	Legend,
	Tooltip,
	ResponsiveContainer,
} from 'recharts';
import PropTypes from 'prop-types';
import moment from 'moment';
import { priceFormatter } from '~/helpers/price';
import { LoaderMini } from '~/components/Loaders';
import { color } from '~/assets/styles/colors';
import { Text } from '~/components/Text';

function RetornaTooltip(prop) {
	const { payload, label, active } = prop;

	if (active) {
		return (
			<div
				className="recharts-default-tooltip"
				style={{
					margin: 0,
					padding: 10,
					backgroundColor: color.white,
					border: `1px solid ${color.grayMedium}`,
					whiteSpace: 'nowrap',
				}}>
				<p className="mb-0" style={{ fontWeight: 700 }}>
					{moment(label).format('DD/MM')}
				</p>
				<p
					className="mb-2"
					style={{ color: payload[0].stroke, fontWeight: 700 }}>
					{`Vendas: R$ ${priceFormatter(payload[0].value)}`}
				</p>
			</div>
		);
	}
	return null;
}

export function GraficoEvolutivo(props) {
	const { data, loading } = props;
	const newData = [...data];
	const [objMax] = newData.sort(
		(itemA, itemB) => itemB.valor_total - itemA.valor_total
	);
	let valorMax = 0;

	if (objMax) {
		valorMax = objMax.valor_total;
	}

	function retornaLegenda(legend) {
		return legend === 'valor_total' && 'Vendas';
	}

	if (loading) {
		return (
			<div
				className="d-flex justify-content-center align-items-center"
				style={{ height: '400px' }}>
				<LoaderMini width="70" />
			</div>
		);
	}

	if (!loading && data.length === 0) {
		return <Text>Sem resultados no periodo</Text>;
	}

	return (
		<div
			style={{
				width: '100%',
				height: '100%',
				maxHeight: 400,
			}}>
			<ResponsiveContainer>
				<LineChart data={data}>
					<CartesianGrid strokeDasharray="2 2" />
					<XAxis
						dataKey="data_transacao"
						tickFormatter={(tick) => moment(tick).format('DD/MM')}
						tick={{ fontSize: 10 }}
						stroke="black"
					/>
					<YAxis
						domain={[0, parseInt(valorMax * 1.5, 10)]}
						tickFormatter={(tick) => priceFormatter(tick)}
						tick={{ fontSize: 10 }}
						stroke="black"
					/>
					<Tooltip content={<RetornaTooltip />} />
					<Legend formatter={(legend) => retornaLegenda(legend)} />
					<Line
						type="monotone"
						dataKey="valor_total"
						stroke={color.secondary}
						activeDot={{ r: 8 }}
						strokeWidth={3}
					/>
				</LineChart>
			</ResponsiveContainer>
		</div>
	);
}

GraficoEvolutivo.propTypes = {
	data: PropTypes.oneOfType([PropTypes.array]),
	loading: PropTypes.bool.isRequired,
};

GraficoEvolutivo.defaultProps = {
	data: [],
};
